<template lang="pug">

  .course-points-shop-product
    .course-points-shop-product__header(
      :style="{backgroundImage: `url('`+product.img+`')`}"
    )
      .course-points-shop-product__prices
        p.course-points-shop-product__price
          span(v-if="product.price")
            | {{product.price}} {{getNoun(product.price, 'балл', 'балла', 'баллов')}}
          span(v-else)
            | Бесплатно
    .course-points-shop-product__content
      .course-points-shop-product__content-top
        p.course-points-shop-product__title(v-if="product.title")
          | {{product.title}}
        p.course-points-shop-product__description(v-if="product.description")
          | {{product.description}}
        p.course-points-shop-product__more(
          v-if="product.fullDescription"
          @click="showProductPopup"
        )
          | Подробнее
      .course-points-shop-product__offers
        UiButton.-s-.course-points-shop-product__offer(
          @click="showPurchasePopup"
          :disabled="balance < product.price"
        )
          | {{product.buttonText}}

</template>

<script>
import _ from 'lodash';

export default {
  props: ['propProduct', 'balance'],
  data: () => ({
    product: {}
  }),
  mounted() {
    this.product = _.cloneDeep(this.propProduct);
  },
  methods: {
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    showProductPopup() {
      this.$store.dispatch('coursePointsShop/setData', {
        path: 'productForPopup',
        value: this.product
      });
    },
    showPurchasePopup() {
      if (!this.product.price && this.product.url) {
        window.open(this.product.url);
        return;
      } else if (this.balance >= this.product.price) {
        this.$store.dispatch('coursePointsShop/setData', {
          path: 'popupOffer',
          value: this.product
        });
      }
    }
  }
};
</script>
